import React from 'react';
import { getConfig } from '../../../helpers';
import { getVisualizationformFields, submitToMarketo } from '../utilities/form-utilities';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

function getMarketoAPIVariant(variant: string): string {
    return getConfig(`components.request-a-trial.marketoAPIVariant.${variant}`, 'Visualization') as string;
}

function getDefaultSubmissionBody(
    data: RequestATrialState
) {
    const ratAPIRequest: RATVisualizationRequest = {
        firstName: data.FirstName,
        lastName: data.LastName,
        email: data.Email,
        phone: data.Phone,
        city: data.City,
        state: data.State ? String(data.State) : '',
        country: data.Country as string,
        company: data.Company,
        companyType1c: data.CompanyType as string,
        jobFunction1c: data.JobFunction as string,
        marketplaceVisualizationType: data.InterestOption,
        marketplaceBITool: data.PreferredBITools,
        marketplaceDatasetFollowup: data.RequestMoreInfo,
        spProductServiceInterestDetailsc: data.OtherInterest
    } as RATVisualizationRequest;
    return ratAPIRequest;
}

function RequestTrialVisualization(props: RequestATrialFormProps) {
    const { productName = '', marketMSADataLink, dataFilePath, marketplaceMSATooltip, productVariant, variant, titleText, keyPageIdPageText, formTextFields } = props;
    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        data.OtherInterest = productName.concat(' Visualization');
        let requestBody = getDefaultSubmissionBody(data);
        requestBody = {
            ...requestBody,
            variant: getMarketoAPIVariant(variant || '')
        };
        submitToMarketo(requestBody, cb, error);
    };
    return (
        <RequestTrialForm
            onSubmitForm={onSubmit}
            formTextFields={formTextFields || getVisualizationformFields()}
            productVariant={productVariant}
            keyPageIdPageText={keyPageIdPageText}
            titleText={titleText}
            marketMSADataLink={marketMSADataLink}
            dataFilePath={dataFilePath}
            marketplaceMSATooltip={marketplaceMSATooltip}
            productName={productName}
            headerVariant={variant}
        />
    );
}

export default React.memo(RequestTrialVisualization);
